import { CommonModule } from "@angular/common";
import { Component, OnInit, signal } from "@angular/core";
import { OrderWizardService } from "../../_service/order-wizard.service";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";
import { SessionUpdateRequest } from "src/app/shared/session/session-update-request.model";
import { OrderPaymentSuccessComponent } from "./success/payment-success.component";
import { OrderPaymentFailureComponent } from "./failure/payment-failure.component";

@Component({
    selector: 'order-payment-result',
    templateUrl: './payment-result.component.html',
    imports: [CommonModule, OrderPaymentSuccessComponent, OrderPaymentFailureComponent]
})
export class OrderPaymentResultComponent implements OnInit {
    isSuccess: boolean = false;
    isFailure: boolean = false;
    sessionId : string = '';

    // stripePaymentId = signal("");
    // stripeStatus = signal("");
    
    constructor(
        public _orderWizardService: OrderWizardService,
        private _httpClient: HttpClient,
        private _activatedRoute: ActivatedRoute
    ) {
        this._activatedRoute.queryParams.subscribe(params => {
            const success = params['success'];
            if (success === 'true') {
                this.isSuccess = true;
                // console.log('Payment successful!');
            } else if (success === 'false') {
                this.isFailure = true;
                // console.log('Payment failed or was cancelled.');
            } else {
                this.isFailure = true;
                // console.log('No payment status found in query parameters.');
            }
            this.sessionId = params['userSessionId'] || '';
        });
     }

    ngOnInit(): void {
        this._httpClient.get<SessionUpdateRequest>("api/session/get").subscribe((response) => {
            this._orderWizardService.updateAfterPayment(response.wizardData!);
            //  if(response?.wizardData?.step06){
            //      this.stripePaymentId.set(response.wizardData.step06.stripeId ?? "null");
            //      this.stripeStatus.set(response.wizardData.step06.status ?? "null");
            //  }
         });
    }


}